import Modules from 'shared_modules/Modules';

export const TEST_FREQUENCY = 5 * 60 * 1000; // 5 minutes
export const TEST_FREQUENCY_DEBUG = 30 * 1000; // 30 seconds for debugging on dev/staging

export const STORAGE_KEY_BACKOFF = 'NetworkHealthToolBackoff';
export const STORAGE_KEY_LAST_FAIL_RUN = 'NetworkHealthToolLastFailRun';
export const BACKOFF_STEP = 15 * 60 * 1000; // 15 minutes
export const BACKOFF_STEP_DEBUG = 60 * 1000; // 1 minute for debugging on dev/staging
export const MAX_BACKOFF = 5; // max 1 hour backoff (15 minutes * 4) - fist step is normal frequency

export const getBackoff = (): number => {
  let backoff = Number(localStorage.getItem(STORAGE_KEY_BACKOFF) ?? 0);
  if (isNaN(backoff) || backoff < 0) backoff = 0;
  if (backoff > MAX_BACKOFF) backoff = MAX_BACKOFF;
  return backoff;
};

export const increaseBackoff = (): void => {
  let backoff = getBackoff();
  backoff += 1;
  if (backoff > MAX_BACKOFF) backoff = MAX_BACKOFF;
  localStorage.setItem(STORAGE_KEY_BACKOFF, backoff.toString());
  localStorage.setItem(STORAGE_KEY_LAST_FAIL_RUN, Date.now().toString());
};

export const resetBackoff = (): void => {
  localStorage.removeItem(STORAGE_KEY_BACKOFF);
  localStorage.removeItem(STORAGE_KEY_LAST_FAIL_RUN);
};

export const getTestFrequency = (): number => {
  return Modules.hasModule('support.network_health_tool.debug')
    ? TEST_FREQUENCY_DEBUG
    : TEST_FREQUENCY;
};

export const getBackoffStep = (): number => {
  return Modules.hasModule('support.network_health_tool.debug') ? BACKOFF_STEP_DEBUG : BACKOFF_STEP;
};

export const computeNextRunFromElapsed = (_elapsed: number | null): number => {
  let elapsed = _elapsed;
  const backoff = getBackoff();
  if (backoff) {
    const time = Number(localStorage.getItem(STORAGE_KEY_LAST_FAIL_RUN));
    if (!isNaN(time)) {
      elapsed = Date.now() - time;
      const interval = backoff === 1 ? getTestFrequency() : getBackoffStep() * (backoff - 1);
      return elapsed >= interval ? 0 : Math.max(interval - elapsed, 0);
    }
  }
  const interval = getTestFrequency();
  return elapsed === null || elapsed >= interval ? 0 : Math.max(interval - elapsed, 0);
};
